import styles from './Ordertable.module.css'
import { useEffect, useRef, useState } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import { ko } from "date-fns/esm/locale";
import { addDays, differenceInDays } from 'date-fns';
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import swal from 'sweetalert';
import { dbService } from 'fbase';
import { addDoc, collection } from "firebase/firestore";

function Reviewtable({userObj}){
    const form = useRef();
    const sendReview = (e) => {
        e.preventDefault();
        onSubmit().then(swal("리뷰 작성이 완료되었습니다!", "","success").then((okay)=>{
            window.location.replace(process.env.PUBLIC_URL + "/review");
        }))
    };
    const onSubmit = async (event) => {
        const reviewObj = {
            ...inputs,
            days,
            term,
            createdAt: new Date(),
            createdTime: Date.now()
        }
        await addDoc(collection(dbService, "reviewlist"), reviewObj);
    }
    const [inputs, setInputs] = useState({
        name: "",
        email: "",
        nation: "",
        city: "",
        age: "",
        travelType: "",
        gender: "",
        food: "",
        place: "",
        gift: "",
        tips: "",
        pack: "",
        notGood: ""
    });

    const {name, email, nation, city, food, place, gift, pack, tips, notGood} = inputs;

    useEffect(()=>{
        if(userObj){
            setInputs({
                ...inputs,
                email: userObj.email,
            })
        } else {
            setInputs({
                ...inputs,
            })
        }
    }, [userObj])

    const onChange = (e) => {
        const {name, value} = e.target;
        setInputs({
            ...inputs,
            [name]: value,
        })
    }

    const [state, setState] = useState([
        {
            startDate: new Date(),
            endDate: addDays(new Date(), 7),
            key: "selection",
        }
    ])

    const firstDay = new Intl.DateTimeFormat("kr-KO").format(state[0].startDate);
    const lastDay = new Intl.DateTimeFormat("kr-KO").format(state[0].endDate);

    const [days, setDays] = useState(differenceInDays(state[0].endDate, state[0].startDate));
    const [term, setTerm] = useState(`${firstDay} ~ ${lastDay}`)

    useEffect(()=>{
        setDays(differenceInDays(state[0].endDate, state[0].startDate));
        setTerm(`${firstDay} ~ ${lastDay}`)
    }, [state])

    return (
        <section className="page-section" id="review">
            <div className="container">
                <div className="text-center">
                    <h2 className="section-heading text-uppercase">review</h2>
                    <div className="row text-center">
                        <form ref={form} onSubmit={sendReview}>
                            <table border="solid" className={styles.orderTable}>
                                <thead>
                                    <tr>
                                        <th>이름*</th>
                                        <td>
                                            <input
                                                type="text"
                                                name="name"
                                                placeholder="김캐리"
                                                id="username"
                                                className={styles.input}
                                                onChange={onChange}
                                                value={name}
                                                required
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>이메일*</th>
                                        <td>
                                            <input
                                                type="email"
                                                name="email"
                                                placeholder="example@mail.com"
                                                id="useremail"
                                                className={styles.input}
                                                value={email}
                                                onChange={onChange}
                                                required
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>성별*</th>
                                        <td>
                                            <label className={styles.label} htmlFor="male">
                                                <input type="radio" id='male' name='gender' value="남성" onChange={onChange} required/>
                                                남성
                                            </label>
                                            <label className={styles.label} htmlFor="female">
                                                <input type="radio" id='female' name='gender' value="여성" onChange={onChange} required/>
                                                여성
                                            </label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>연령대*</th>
                                        <td>
                                            <select name='age' id='age' className={styles.select} onChange={onChange} required>
                                                <option>선 택</option>
                                                <option value="10대">10대</option>
                                                <option value="20대">20대</option>
                                                <option value="30대">30대</option>
                                                <option value="40대">40대</option>
                                                <option value="50대 이상">50대 이상</option>
                                            </select>
                                        </td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th>여행유형*</th>
                                        <td>
                                            <select name='travelType' id='travelType' className={styles.select} onChange={onChange} required>
                                                <option>선 택</option>
                                                <option value="자유여행">자유여행</option>
                                                <option value="가족여행">가족여행</option>
                                                <option value="수학여행">수학여행</option>
                                                <option value="신혼여행">신혼여행</option>
                                                <option value="출장/업무">출장/업무</option>
                                                <option value="유학/연수">유학/연수</option>
                                                <option value="봉사활동">봉사활동</option>
                                                <option value="기타여행">기타여행</option>
                                            </select>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className={styles.orderTh}>여행지*</th>
                                        <td className={styles.orderTd}>
                                            <input
                                                type="text"
                                                name="nation"
                                                placeholder="국가"
                                                id="nation"
                                                className={styles.input}
                                                value={nation}
                                                onChange={onChange}
                                                required
                                            />
                                            <br />
                                            <input
                                                type="text"
                                                name="city"
                                                placeholder="도시"
                                                id="city"
                                                className={styles.input}
                                                value={city}
                                                onChange={onChange}
                                                required
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className={styles.orderTh} colSpan="3">여행기간(대략적으로)*</th>
                                    </tr>
                                    <tr>
                                        <td className={styles.orderTd} colSpan="2">
                                        <DateRange
                                            ranges={state}
                                            locale={ko}
                                            onChange={(item) => {
                                                setState([item.selection])
                                            }}
                                            required
                                        />
                                        </td>
                                    </tr>
                                    <tr className={styles.none}>
                                        <th className={styles.orderTh}></th>
                                        <td className={styles.orderTd}>
                                            <input type="text" name="term" value={term} readOnly />
                                        </td>
                                    </tr>
                                    <tr className={styles.none}>
                                        <th className={styles.orderTh}>여행일수</th>
                                        <td className={styles.orderTd}>
                                            <input type="text" name="days" className={styles.days} value={days} readOnly />일
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>추천음식</th>
                                        <td>
                                            <input type="text" id='food' value={food} name='food' className={styles.recom} placeholder='추천음식 2-4가지' onChange={onChange} required />
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>추천명소</th>
                                        <td>
                                            <input type="text" id='place' value={place} name='place' className={styles.recom} placeholder='추천명소 2-4곳' onChange={onChange} required />
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>추천선물/기념품</th>
                                        <td>
                                            <input type="text" id='gift' value={gift} name='gift' className={styles.recom} placeholder='선물/기념품 2-3개' onChange={onChange} required />
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>짐쌀 때<br/>챙겨야 할 물건</th>
                                        <td>
                                            <input type="text" id='pack' value={pack} name='pack' className={styles.recom} placeholder='필수품 1-3개' onChange={onChange} required />
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>비추천음식/장소/선물</th>
                                        <td>
                                            <input type="text" id='notGood' value={notGood} name='notGood' className={styles.recom} placeholder='비추...' onChange={onChange} required />
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>나만의 여행 꿀팁</th>
                                        <td>
                                            <input type="text" id='tips' value={tips} name='tips' placeholder='꿀팁 1-3가지' className={styles.recom} onChange={onChange} required />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan="2">
                                            <p className={styles.p}>마땅히 답하실 내용이 없으시면 없음!이라고 적어주세요.</p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <input type="submit" name="submit" className="btn" value="작성완료" />
                        </form>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Reviewtable;